/**
 * 分页
 */
import { PAGE_SIZE, CURRENT_PAGE } from './constants';

export default class Page {
  constructor({ data = [], header = [], pageSize = PAGE_SIZE, currentPage = CURRENT_PAGE, total = 0 } = {}) {
    this.data = data;
    this.originalData = data;
    this.header = header;
    this.pageSize = pageSize;
    this.currentPage = currentPage;
    this.total = total;
    this.loading = false;
  }

  _formatHeaderData(header) {
    let result = {};
    for (let item of header) {
      for (let key in item) {
        // result.push({
        //   field: key,
        //   name: header[key]
        // });
        result[key] = item[key];
      }
    }
    return result;
  }

  setOriginalData (data = []) {
    this.originalData = data
  }

  setPageData({ data, list = [], header = [], total, count, pageSize, currentPage, loading = false } = {}, format = true) {
    this.header = format ? this._formatHeaderData(header) : header;
    this.data = data || list || [];
    this.total = total || count || PAGE_SIZE;
    if (pageSize) this.pageSize = pageSize;
    if (currentPage) this.currentPage = currentPage;
    this.loading = loading;
  }

  getPageData(data, pageSize, currentPage) {
    pageSize = pageSize || this.pageSize;
    currentPage = currentPage || this.currentPage;
    return data.slice(pageSize * (currentPage - 1), pageSize * currentPage);
  }

  clearHeader() {
    this.loading = true;
    if (this.header.length > 0) {
      this.header.length = 0;
    }
  }

  clearData() {
    this.loading = true;
    if (this.data.length > 0 || this.originalData.length > 0) {
      this.data.length = 0;
      this.originalData.length = 0
    }
  }

  resetData({ pageSize = PAGE_SIZE, currentPage = CURRENT_PAGE } = {}) {
    this.loading = true;
    if (this.data.length > 0 || this.originalData.length > 0) {
      this.data.length = 0;
      this.originalData.length = 0;
      this.pageSize = pageSize;
      this.currentPage = currentPage;
    }
  }
}
